.theme-brand-signnow {
  .footer-type-5 {
    .me-container {
      padding-bottom: 0;
    }
  }

  .footer-menu-type-1__items {
    .me-button {
      text-align: left;
    }
  }

  [slot='menus'] {
    display: flex;
    flex-direction: column;

    footer-menu-type-1:nth-child(2) {
      margin-top: map-get($spacings, md);
    }
  }
}

.form-free-trial-type-1 {
  display: flex;

  @include above($breakpoint-desktop-md) {
    justify-content: flex-end;
  }
}

.footer-apps-list {
  display: flex;
  margin-top: 0;
  margin-bottom: 0;
}

.footer-apps-list__item {
  margin-bottom: 0;

  &:first-child {
    margin-right: 12px;
  }
}

.footer-apps-list__item svg {
  display: block;

  &:hover {
    opacity: 0.85;
    transition: opacity 0.2s;
  }
}

.footer-apps-list__link {
  display: flex;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    border-radius: 4px;
    border-width: 2px;
    box-shadow:
      0 0 0 var(--border-size-md) var(--color-neutral-white),
      0 0 0 var(--border-size-lg) var(--color-brand-primary-light);

    &::after {
      opacity: 0;
    }
  }
}

.footer-apps-list__info {
  display: flex;
  align-items: center;

  // @include above($media-screen-desktop) {
  justify-content: flex-start;
  margin-top: 8.5px;

  // }
}

.footer-apps-list__star {
  margin-right: 4px;

  svg {
    vertical-align: unset;
  }
}

.footer-apps-list__star-value {
  position: relative;
  margin-right: 8px;
  font-weight: 700;
  font-size: 11px;
  line-height: 16px;
  color: #2c2c2c;

  &::after {
    position: absolute;
    content: '';
    top: 4px;
    right: -4px;
    background-color: #b9c2c8;
    border-radius: 50%;
    width: 1px;
    height: 8px;
  }
}

.footer-apps-list__ratings {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #2c2c2c;
}

.footer-column__social--mobile {
  .footer-apps-list {
    display: flex;
    justify-content: center;
  }

  .footer-apps-list__item {
    // @include above($media-screen-tablet) {
    margin-bottom: 28px;

    // }
  }
}
